import { PRIVACY_POLICY } from './policyContent';

export const MOBILE_PRIVACY_POLICY = PRIVACY_POLICY;

export const MOBILE_TERMS = [
  <>
    <p className="whitespace-pre-line text-[16px] md:text-[18px] font-[550] mb-2">약관안내</p>
    <br />
    <p className="whitespace-pre-line text-[16px] md:text-[18px] font-[550] mb-2">제1조 목적</p>
    <p className="whitespace-pre-line text-[14px] md:text-base leading-relaxed">
      {`이 약관은 브이드림 ("회사" 또는 "브이드림")가 제공하는 브이드림 사이트 및 관련 제반 서비스의 이용과 관련하여 회사와 회원과의 권리, 의무 및 책임사항, 기타 필요한 사항을 규정하는 것을 목적으로 합니다.`}
    </p>
    <br />
    <p className="whitespace-pre-line text-[16px] md:text-[18px] font-[550] mb-2">제2조 정의</p>
    <p className="whitespace-pre-line text-[14px] md:text-base leading-relaxed">
      {`이 약관에서 사용하는 용어의 정의는 다음과 같습니다.
① "서비스"라 함은 구현되는 단말기(PC, TV, 휴대형단말기 등의 각종 유무선 장치를 포함)와 상관없이 "회원"이 이용할 수 있는 브이드림 사이트 및 관련 제반 서비스를 의미합니다.
② "회원"이라 함은 회사의 "서비스"에 접속하여 이 약관에 따라 "회사"와 이용계약을 체결하고 "회사"가 제공하는 "서비스"를 이용하는 고객을 말합니다.
③ "게시물"이라 함은 "회원"이 "서비스"를 이용함에 있어 "서비스상"에 게시한 정보 형태의 글, 사진, 동영상 및 각종 파일과 링크 등을 의미합니다.`}
    </p>
    <br />
    <p className="whitespace-pre-line text-[16px] md:text-[18px] font-[550] mb-2">제3조 약관의 게시와 개정</p>
    <p className="whitespace-pre-line text-[14px] md:text-base leading-relaxed">
      {`① "회사"는 이 약관의 내용을 "회원"이 쉽게 알 수 있도록 사이트 하단에 게시합니다.
② "회사"는 "약관의규제에관한법률", "정보통신망이용촉진및정보보호등에관한법률(이하 "정보통신망법")" 등 관련법을 위배하지 않는 범위에서 이 약관을 개정할 수 있습니다.
③ "회사"가 약관을 개정할 경우에는 적용일자 및 개정사유를 명시하여 현행약관과 함께 제1항의 방식에 따라 그 개정약관의 적용일자 30일 전부터 적용일자 전일까지 공지합니다.`}
    </p>
    <br />
    <p className="whitespace-pre-line text-[16px] md:text-[18px] font-[550] mb-2">제4조 약관의 해석</p>
    <p className="whitespace-pre-line text-[14px] md:text-base leading-relaxed">
      {`① "회사"는 개별 서비스에 대해서는 별도의 이용약관 및 정책(이하 "개별 모바일 홈페이지 서비스약관 등")을 둘 수 있으며, 해당 내용이 이 약관과 상충할 경우에는 "개별 모바일 홈페이지 서비스약관 등"이 우선하여 적용됩니다.
② 이 약관에서 정하지 아니한 사항이나 해석에 대해서는 "개별 모바일 홈페이지 등" 및 관계법령 또는 상관례에 따릅니다.`}
    </p>
    <br />
    <p className="whitespace-pre-line text-[16px] md:text-[18px] font-[550] mb-2">제5조 이용계약 체결</p>
    <p className="whitespace-pre-line text-[14px] md:text-base leading-relaxed">
      {`① 이용계약은 구직을 하고자 하는 자 또는 구인을 하고자 하는 자(이하 "이용자")가 약관의 내용에 대하여 동의를 한 다음 브이드림 서비스 신청을 하고 "회사"가 이러한 신청에 대하여 승낙함으로써 체결됩니다.
② "회사"는 "이용자"의 신청에 대하여 "서비스" 이용을 승낙함을 원칙으로 합니다. 다만, "회사"는 다음 각 호에 해당하는 신청에 대하여는 승낙을 하지 않거나 사후에 이용계약을 해지할 수 있습니다.
ㅤ1. 이용자가 이 약관에 의하여 이전에 서비스 이용자격을 상실한 적이 있는 경우
ㅤ2. 실명이 아니거나 타인의 명의를 이용한 경우
ㅤ3. 허위의 정보를 기재하거나, "회사"가 제시하는 내용을 기재하지 않은 경우
ㅤ4. 이용자의 귀책사유로 인하여 승인이 불가능하거나 기타 규정한 제반 사항을 위반하며 신청하는 경우`}
    </p>
    <br />
    <p className="whitespace-pre-line text-[16px] md:text-[18px] font-[550] mb-2">제6조 개인정보보호 의무</p>
    <p className="whitespace-pre-line text-[14px] md:text-base leading-relaxed">
      {`"회사"는 "정보통신망법" 등 관계 법령이 정하는 바에 따라 "회원"의 개인정보를 보호하기 위해 노력합니다. 개인정보의 보호 및 사용에 대해서는 관련법 및 "회사"의 개인정보취급방침이 적용됩니다.`}
    </p>
    <br />
    <p className="whitespace-pre-line text-[16px] md:text-[18px] font-[550] mb-2">{'제7조 "회원"에 대한 통지'}</p>
    <p className="whitespace-pre-line text-[14px] md:text-base leading-relaxed">
      {`① "회사"가 "이용자"에 대한 통지를 하는 경우 이 약관에 별도 규정이 없는 한 서비스 내 전자우편주소, 전자쪽지 등으로 할 수 있습니다.
② "회사"는 "이용자" 전체에 대한 통지의 경우 7일 이상 "회사"의 게시판에 게시함으로써 제1항의 통지에 갈음할 수 있습니다.`}
    </p>
    <br />
    <p className="whitespace-pre-line text-[16px] md:text-[18px] font-[550] mb-2">{'제8조 "회사"의 의무'}</p>
    <p className="whitespace-pre-line text-[14px] md:text-base leading-relaxed">
      {`① "회사"는 관련법과 이 약관이 금지하거나 미풍양속에 반하는 행위를 하지 않으며, 계속적이고 안정적으로 "서비스"를 제공하기 위하여 최선을 다하여 노력합니다.
② "회사"는 "이용자"가 안전하게 "서비스"를 이용할 수 있도록 개인정보(신용정보 포함)보호를 위해 보안시스템을 갖추어야 하며 개인정보취급방침을 공시하고 준수합니다.`}
    </p>
    <br />
    <p className="whitespace-pre-line text-[16px] md:text-[18px] font-[550] mb-2">{'제9조 "이용자"의 의무'}</p>
    <p className="whitespace-pre-line text-[14px] md:text-base leading-relaxed">
      {`① "이용자"는 다음 행위를 하여서는 안 됩니다.
ㅤ1. 신청 또는 변경 시 허위내용의 등록
ㅤ2. 타인의 정보도용
ㅤ3. "회사"가 게시한 정보의 변경
ㅤ4. "회사"가 정한 정보 이외의 정보(컴퓨터 프로그램 등) 등의 송신 또는 게시
ㅤ5. "회사"와 기타 제3자의 저작권 등 지적재산권에 대한 침해
ㅤ6. "회사" 및 기타 제3자의 명예를 손상시키거나 업무를 방해하는 행위
ㅤ7. 외설 또는 폭력적인 메시지, 화상, 음성, 기타 공서양속에 반하는 정보를 "서비스"에 공개 또는 게시하는 행위
ㅤ8. 회사의 동의 없이 영리를 목적으로 "서비스"를 사용하는 행위
ㅤ9. 기타 불법적이거나 부당한 행위`}
    </p>
    <br />
    <p className="whitespace-pre-line text-[16px] md:text-[18px] font-[550] mb-2">{'제10조 "서비스"의 제공 등'}</p>
    <p className="whitespace-pre-line text-[14px] md:text-base leading-relaxed">
      {`① 회사는 이용자에게 아래와 같은 서비스를 제공합니다.
ㅤ1. 게시판형 서비스(1:1문의, 장애인 구직등록, 지원이력서 확인, 고용부담금절감 신청)
ㅤ2. 기타 "회사"가 추가 개발하거나 다른 회사와의 제휴계약 등을 통해 "이용자"에게 제공하는 일체의 서비스
② "서비스"는 연중무휴, 1일 24시간 제공함을 원칙으로 합니다.`}
    </p>
    <br />
    <p className="whitespace-pre-line text-[16px] md:text-[18px] font-[550] mb-2">{'제11조 준거법 및 재판관할'}</p>
    <p className="whitespace-pre-line text-[14px] md:text-base leading-relaxed">
      {`① "회사"와 "이용자" 간 제기된 소송은 대한민국법을 준거법으로 합니다.
② "회사"와 "이용자"간 발생한 분쟁에 관한 소송은 제소 당시의 "이용자"의 주소에 의하고, 주소가 없는 경우 거소를 관할하는 지방법원의 전속관할로 합니다.`}
    </p>
    <br />
    <p className="whitespace-pre-line text-[16px] md:text-[18px] font-[550] mb-2">부칙</p>
    <p className="whitespace-pre-line text-[14px] md:text-base leading-relaxed">{`① 이 약관은 2020년 01월 01일부터 적용됩니다.`}</p>
  </>,
];
